import styled from 'styled-components/macro';

export const StyledMultiSelect = styled.div<{
  isSelected: boolean;
  isDisabled?: boolean;
}>`
  background-color: ${(props) => (props.isSelected ? '#2D67D8' : '#FFFFFF')};
  color: ${(props) =>
    props.isDisabled ? '#697180' : props.isSelected ? '#FFFFFF' : '#1F2939'};
  border: ${(props) =>
    props.isSelected ? 'solid 1px #2D67D8' : 'solid 1px #CED5DE'};
  font-size: 14px;
  font-weight: 400;
  padding: 8px 12px 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  pointer-events: ${(props) => props.isDisabled && 'none'};

  &:hover {
    background-color: ${(props) => (props.isSelected ? '#1D4ED6' : '#FFFFFF')};
    color: ${(props) => (props.isSelected ? '#FFFFFF' : '#1D4ED6')};
    border: ${(props) =>
      props.isSelected ? 'solid 1px #2D67D8' : 'solid 1px #1D4ED6'};
  }
`;
